import { Terminal } from "../../Terminal";

export function clear(): undefined {
  Terminal.clear();
}
